<div class="md:tw-p-6 tw-max-w-6xl tw-mx-auto">
  <div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between tw-gap-4 tw-mb-6">
    <div>
      <h1 class="tw-text-2xl tw-font-bold tw-text-gray-900">Blacklist</h1>
      <p class="tw-text-sm tw-text-gray-500 tw-mt-1">Block a user by email address, IP address, or both.</p>
    </div>
    <button
      type="button"
      (click)="onAdd()"
      [disabled]="isFormOpen() || isLoading()"
      class="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-text-sm tw-font-medium tw-rounded-lg tw-shadow-sm hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
    >
      <svg class="tw-w-5 tw-h-5 tw-mr-2 tw-text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      Add to blacklist
    </button>
  </div>

  @if (isFormOpen()) {
  <form [formGroup]="form" (ngSubmit)="onSave()" class="tw-bg-white tw-rounded-lg tw-shadow-md tw-border tw-border-gray-200 tw-p-6 tw-mb-6">
    <h2 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-1">Add to blacklist</h2>
    <p class="tw-text-sm tw-text-gray-500 tw-mb-4">Email and IP are optional on their own. At least one is required.</p>

    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
      <div>
        <label for="blacklist-email" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Email</label>
        <input
          id="blacklist-email"
          type="email"
          formControlName="email"
          placeholder="bad.user@example.com"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-rounded-lg tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm"
          [class.tw-border-red-500]="form.get('email')?.invalid && form.get('email')?.touched"
          [class.tw-border-gray-300]="!(form.get('email')?.invalid && form.get('email')?.touched)"
        />
        @if (form.get('email')?.invalid && form.get('email')?.touched && form.get('email')?.errors?.['email']) {
        <p class="tw-text-xs tw-text-red-500 tw-mt-1">Enter a valid email address.</p>
        }
      </div>

      <div>
        <label for="blacklist-ip" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">IP address</label>
        <input
          id="blacklist-ip"
          type="text"
          formControlName="ip_address"
          placeholder="203.0.113.10"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-rounded-lg tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm"
          [class.tw-border-red-500]="form.get('ip_address')?.invalid && form.get('ip_address')?.touched"
          [class.tw-border-gray-300]="!(form.get('ip_address')?.invalid && form.get('ip_address')?.touched)"
        />
        @if (form.get('ip_address')?.invalid && form.get('ip_address')?.touched && form.get('ip_address')?.errors?.['ip']) {
        <p class="tw-text-xs tw-text-red-500 tw-mt-1">Enter a valid IP address.</p>
        }
      </div>

      <div>
        <label for="blacklist-name" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Full name</label>
        <input
          id="blacklist-name"
          type="text"
          formControlName="full_name"
          placeholder="Optional"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm"
        />
      </div>

      <div>
        <label for="blacklist-phone" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Phone number</label>
        <input
          id="blacklist-phone"
          type="text"
          formControlName="phone_number"
          placeholder="Optional"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm"
        />
      </div>

      <div>
        <label for="blacklist-country" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">Country</label>
        <input
          id="blacklist-country"
          type="text"
          formControlName="country"
          maxlength="2"
          placeholder="QA"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-rounded-lg tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-text-sm tw-uppercase"
          [class.tw-border-red-500]="form.get('country')?.invalid && form.get('country')?.touched"
          [class.tw-border-gray-300]="!(form.get('country')?.invalid && form.get('country')?.touched)"
        />
        @if (form.get('country')?.invalid && form.get('country')?.touched) {
        <p class="tw-text-xs tw-text-red-500 tw-mt-1">Use a 2-letter country code.</p>
        }
      </div>
    </div>

    @if (form.errors?.['emailOrIpRequired'] && form.touched) {
    <p class="tw-text-xs tw-text-red-500 tw-mt-3">Enter an email address or an IP address.</p>
    }

    <div class="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-pt-4 tw-mt-4 tw-border-t tw-border-gray-200">
      <button
        type="button"
        (click)="onCancel()"
        [disabled]="isSaving()"
        class="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-gray-500 focus:tw-ring-offset-2 disabled:tw-opacity-50 tw-transition-colors"
      >
        Cancel
      </button>
      <button
        type="submit"
        [disabled]="isSaving()"
        class="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-bg-blue-600 tw-border tw-border-transparent tw-rounded-lg tw-shadow-sm hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
      >
        @if (isSaving()) {
        <svg class="tw-animate-spin tw-h-4 tw-w-4 tw-mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        }
        {{ isSaving() ? 'Adding...' : 'Add to blacklist' }}
      </button>
    </div>
  </form>
  }

  <div class="tw-mb-4">
    <app-search-field placeholder="Search blacklist" (searchChange)="onSearch($event)" />
  </div>

  @if (isLoading()) {
  <div class="tw-flex tw-items-center tw-justify-center tw-py-12">
    <svg class="tw-animate-spin tw-h-8 tw-w-8 tw-text-blue-600" fill="none" viewBox="0 0 24 24">
      <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <span class="tw-ml-3 tw-text-gray-600">Loading blacklist...</span>
  </div>
  }

  @if (!isLoading() && items().length === 0) {
  <div class="tw-text-center tw-py-12 tw-bg-gray-50 tw-rounded-lg tw-border-2 tw-border-dashed tw-border-gray-300">
    <h3 class="tw-text-sm tw-font-medium tw-text-gray-900">No blacklist entries</h3>
    <p class="tw-mt-1 tw-text-sm tw-text-gray-500">Add an email address or IP address to block a user.</p>
  </div>
  }

  @if (!isLoading() && items().length > 0) {
  <div class="tw-overflow-x-auto tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200">
    <table class="tw-min-w-full tw-text-sm tw-text-left">
      <thead class="tw-bg-gray-50 tw-text-gray-500">
        <tr>
          <th class="tw-px-4 tw-py-3 tw-font-medium">Email</th>
          <th class="tw-px-4 tw-py-3 tw-font-medium">IP address</th>
          <th class="tw-px-4 tw-py-3 tw-font-medium">Name</th>
          <th class="tw-px-4 tw-py-3 tw-font-medium">Phone</th>
          <th class="tw-px-4 tw-py-3 tw-font-medium">Country</th>
          <th class="tw-px-4 tw-py-3 tw-font-medium">Added</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of items(); track entry.id) {
        <tr class="tw-border-t tw-border-gray-100">
          <td class="tw-px-4 tw-py-3 tw-text-gray-900">{{ display(entry.email) }}</td>
          <td class="tw-px-4 tw-py-3 tw-text-gray-900">{{ display(entry.ip_address) }}</td>
          <td class="tw-px-4 tw-py-3 tw-text-gray-900">{{ display(entry.full_name) }}</td>
          <td class="tw-px-4 tw-py-3 tw-text-gray-900">{{ display(entry.phone_number) }}</td>
          <td class="tw-px-4 tw-py-3 tw-text-gray-900">{{ display(entry.country) }}</td>
          <td class="tw-px-4 tw-py-3 tw-text-gray-500 tw-whitespace-nowrap">{{ display(entry.created_at) }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if (pagination(); as pager) {
  <div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between tw-gap-3 tw-mt-4">
    <p class="tw-text-sm tw-text-gray-500">Showing {{ rangeStart() }}–{{ rangeEnd() }} of {{ pager.total }}</p>
    <div class="tw-inline-flex tw-self-start sm:tw-self-auto tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-300">
      <button
        type="button"
        class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-bg-white tw-text-gray-500 disabled:tw-opacity-40"
        [disabled]="page() <= 1"
        aria-label="Previous page"
        (click)="goToPage(page() - 1)"
      >
        <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M8.75 2.92L4.67 7L8.75 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      @for (pageNumber of pageNumbers(); track $index) {
      @if (pageNumber === 'ellipsis') {
      <span class="tw-inline-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-bg-white tw-px-2 tw-text-sm tw-text-gray-500">...</span>
      } @else {
      <button
        type="button"
        class="tw-inline-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-px-2 tw-text-sm tw-font-medium"
        [ngClass]="pageNumber === page() ? 'tw-bg-blue-50 tw-text-blue-700' : 'tw-bg-white tw-text-gray-500'"
        [attr.aria-current]="pageNumber === page() ? 'page' : null"
        (click)="goToPage(pageNumber)"
      >
        {{ pageNumber }}
      </button>
      }
      }

      <button
        type="button"
        class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-bg-white tw-text-gray-500 disabled:tw-opacity-40"
        [disabled]="page() >= pager.last_page"
        aria-label="Next page"
        (click)="goToPage(page() + 1)"
      >
        <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M5.25 2.92L9.33 7L5.25 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
  }
  }
</div>
